import React, {useEffect} from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'

import bbl from '../../assets/images/bbl.svg'
import bay from '../../assets/images/bay.svg'
import ktb from '../../assets/images/ktb.svg'
import kbank from '../../assets/images/kbank.svg'
import scb from '../../assets/images/scb.svg'


const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const Icon  = styled.img`
  width: 100%;
  height: auto;
`

const Bank = (props) => {

  const value = [
    {id: 1, text: 'ธนาคารกรุงเทพ จำกัด (มหาชน)', icon: bbl},
    {id: 2, text: 'ธนาคารกสิกรไทย จำกัด (มหาชน)', icon: kbank},
    {id: 3, text: 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน)', icon: scb},
    {id: 4, text: 'ธนาคารกรุงไทย จำกัด (มหาชน)', icon: ktb},
    {id: 5, text: 'ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)', icon: bay}
  ]

  useEffect(() => window.scrollTo(0,0));

  const handleClick = (id,value) => {
    props.setBank(id,value);
    props.history.push('/how-to-book-bank');
  }

  return (
    <Layout title={'เลือกข้อมูล'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกธนาคาร/บริษัท</h4>
      <Row>
        {
          value.map(element => {
            if([1,2,3].includes(element.id)) {
              return (
                <StyledCol key={element.id} onClick={() => handleClick(element.id,element.text)}>
                  <Row style={{marginBottom: '-.5rem'}}>
                    <Col span={2}>
                      <Icon src={element.icon}/>
                    </Col>
                    <Col span={22}>
                      <Text style={{marginLeft: '.5rem'}}>{element.text}</Text>
                    </Col>
                  </Row>
                  <Divider floatRight={true}/>
                </StyledCol>
              )
            } else {
              return (
                <StyledCol key={element.id} onClick={() => handleClick(element.id,element.text)}>
                  <Text>{element.text}</Text>
                  <Divider floatRight={true}/>
                </StyledCol>
              )
            }
          })
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setBank: actions.setBank,
}

const BankWithConnect = connect(null, mapDispatchToProps)(Bank)

export default BankWithConnect
